/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="profileSettings.module.ts" />
///<reference path="../../components/common/ratings.service.ts"/>

module Meevo.Plugins.ProfileSettings {
  class ProfileSettingsController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {
    // statically inject constructor resources
    employeeDetail: Model.DataDetail;
    static $inject = [
      "meevo.AppSettings",
      "$http",
      "meevo.components.common.DataService",
      "meevo.components.modal.ModalService",
      "meevo.components.common.IdentityService",
      "meevo.components.logging.LoggingService",
      "meevo.components.common.SecurityService",
      "meevo.components.tracking.TrackingService",
      "$rootScope",
      "$scope",
      "$state",
      "meevo.ContextParams",
      'meevo.components.short-cuts.ShortCutsService',
      "meevo.components.busy.BusyService",
      "$filter",
      "meevo.components.common.ImageGalleryService",
      "meevo.components.common.RatingsService"];

    constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
      protected $http: angular.IHttpService,
      protected dataService: Meevo.Components.BaseClasses.IDataService,
      protected modalService: Meevo.Components.Modal.IModalService,
      protected identityService: Meevo.Components.Common.IIdentityService,
      protected loggingService: Meevo.Components.Logging.ILoggingService,
      protected securityService: Meevo.Components.Common.ISecurityService,
      protected trackingService: Meevo.Components.Tracking.ITrackingService,
      protected $rootScope: angular.IRootScopeService,
      protected $scope: angular.IScope,
      protected $state: any,
      protected contextParams: Meevo.IContextParams,
      protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
      protected busyService: Meevo.Components.Busy.IBusyService,
      protected $filter: angular.IFilterService,
      protected imageGalleryService: Meevo.Components.Common.IImageGalleryService,
        protected ratingsService: Meevo.Components.Common.IRatingsService) {

      super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService, {
        use: true,
        appAreaEnum: Meevo.Model.AppAreaEnum.Employee
      });

      this.securityService.checkSection(this.meevoSecurityKeys.MANAGEMENT_PROFILESETTINGS)
        .then(() => {



          let permission = this.meevoSecurityKeys.MANAGEMENT_PROFILESETTINGS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ;
        });
    }



    createContext(): void {
      let vm = <ProfileSettingsController>this;
      vm.context = new ProfileSettingsContext(this.appSettings, vm.dataService, vm.modalService, vm.identityService, vm.loggingService, this.securityService, vm.trackingService, vm.$rootScope, vm.busyService, vm.customDataContextConfig, vm.imageGalleryService, vm.ratingsService);
      super.createContext();
      vm.context.activate(vm.selectedItemId, null, vm.asLocationId);
      vm.context.deactivate = () => {
        vm.visualState = Model.MaintenanceFormVisualState.Search;
      }
    }
  }

  angular.module("meevo.plugins.profileSettings")
    .controller("meevo.plugins.profileSettings.ProfileSettingsController", ProfileSettingsController);
}